import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { PaginaProductoComponenete } from "../components/PagesProducto/ComponentePaginaProducto";

const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "name": "Hod vending",
        "url": "https://www.hodvending.cl/producto",
       
        "sameAs": [
          "https://www.facebook.com/profile.php?id=61557919715539",
          "https://www.instagram.com/hodvending",
          "https://www.linkedin.com/company/hod-servicios-logísticos/",
          "https://x.com"
        ]
      },
      {
        "@type": "LocalBusiness",
        "name": "HOD Servicios Logísticos ",
      
        "description": " Descubre nuestra línea de máquinas expendedoras marca Jofemar para snacks, café, congelados y uso industrial. Tecnología de punta, conectividad y eficiencia.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Dirección de su negocio",
          "addressLocality": "Ciudad",
          "addressRegion": "Región",
          "postalCode": "Código Postal",
          "addressCountry": "CL"
        },
        "priceRange": "$$",
        "openingHours": "Mo-Fr 08:00-17:00",
        "url": "https://www.hodvending.cl/producto"
      },
      {
        "@type": "WebPage",
        "name": "Productos",
        "url": "https://www.hodvending.cl/producto",
        "datePublished": "2024-07-01",
        "description": " Descubre nuestra línea de máquinas expendedoras marca Jofemar para snacks, café, congelados y uso industrial. Tecnología de punta, conectividad y eficiencia.",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://www.hodvending.cl/producto"
        }
      }
    ]
  };

export const PaginaProducto = () => {
    
    return(
        <> 
         <HelmetProvider>
               <Helmet>
                 <title> Catálogo de Máquinas Vending Jofemar | HOD Chile</title>
                 <meta
                   name="description"
                   content=" Descubre nuestra línea de máquinas expendedoras marca Jofemar para snacks, café, congelados y uso industrial. Tecnología de punta, conectividad y eficiencia.

       "
                 />
                 <meta
                   name="keywords"
                   content="máquinas vending Chile, soluciones automatizadas, vending para empresas, vending inteligente, distribución automática, Jofemar Chile"
                 />
                 <meta
                   property="og:description"
                   content=" Descubre nuestra línea de máquinas expendedoras marca Jofemar para snacks, café, congelados y uso industrial. Tecnología de punta, conectividad y eficiencia.
"
                 />
                 <meta property="og:type" content="website" />
                 <meta property="og:url" content="https://www.hodvending.cl/producto" />
                 <meta property="og:title" content=" Catálogo de Máquinas Vending Jofemar | HOD Chile" />
                 <meta property="og:image" content="%PUBLIC_URL%/favicon.ico" />
                 <meta name="author" content="HOD Servicios Logísticos " />
                 <meta name="robots" content="index,follow" />
                 <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                 <meta name="publisher" content="HOD Servicios Logísticos " />
                 <link rel="canonical" href="https://www.hodvending.cl/producto" />
                 <script type="application/ld+json">
                   {JSON.stringify(schemaData)}
                 </script>
                  </Helmet>
                       </HelmetProvider>
                          <h1 style={{color:'transparent', position:'absolute', width:'80px', fontSize:'1px'}}> cotizar vending, presupuesto máquinas expendedoras, asesoría vending, cotización automática, soluciones vending, catálogo Jofemar Chile, empresa de vending Chile, historia HOD, vending sostenible, equipo HOD, tecnología vending, Jofemar Chile, máquinas vending Chile, soluciones automatizadas, vending para empresas, vending inteligente, distribución automática, Jofemar Chile, máquinas vending Chile, soluciones automatizadas, vending para empresas, vending inteligente, distribución automática, Jofemar Chile, servicio técnico vending, instalación máquinas vending, mantenimiento vending, soporte postventa, asistencia vending, repuestos Jofemar</h1>
        <PaginaProductoComponenete/>
        </>
    )
}